import React,{ useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader } from 'rsuite';
import * as actionsUser  from '../../../../app/actions/user';
import {getLatin, isNoCyrilicFound, isLatinFound}  from '../../../../app/common/services/vehicle.service';
import { NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';
import {BackIcon} from '../svg/iconsSvg';

const ProfileMyDataEdit = ({onBack, onForward, style}) => {

    const dispatch = useDispatch();

    const userDetails = useSelector(state => state.userDetails);
    
    const [loading, setLoading] = useState(false);

    const [checkFields, setCheckFields] = useState({});

    const [userDataLocal, setUserDataLocal] = useState({
                                                email             : userDetails?.email,
                                                firstNameCyrillic : userDetails?.firstNameCyrillic,
                                                middleNameCyrillic: userDetails?.middleNameCyrillic,
                                                lastNameCyrillic  : userDetails?.lastNameCyrillic,
                                                userPubId         : userDetails?.userPubId,
                                                mobTelephone      : userDetails?.mobTelephone,
                                                address           : userDetails?.userAddresses ? (userDetails?.userAddresses.find(obj => obj.isUserAddress) || {isUserAddress: true}) : {isUserAddress: true}
                                            });

    const goBack = () => onBack(4);

    const onChangeHandler = (field, data, isAddress) =>  {
        if(isAddress) {
            setUserDataLocal({...userDataLocal, address: {...userDataLocal.address, [field]: data}});
            return;
        }
        setUserDataLocal({...userDataLocal, [field]: data});
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForError = (field, type, allFields, isAddress) =>  {
        if(isAddress) {
            switch (type) {
                case 'cyrilic':
                    const nonCyrFound = userDataLocal?.address?.[field] ? isLatinFound(userDataLocal?.address?.[field]) : false;
                    return (checkFields[field] || allFields) && nonCyrFound ;
                default:
                    return false;
            }
        }

        switch (type) {
            case 'cyrilic':
                const nonCyrFound = userDataLocal[field] ? isNoCyrilicFound(userDataLocal[field]) : false;
                return (checkFields[field] || allFields) && nonCyrFound ;
            case 'id':
                console.log('test', checkFields[field])
                return (checkFields[field] || allFields) && (userDataLocal[field] && userDataLocal[field]?.length < 10);
            default:
                return false;
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return 'Полето е задължително на кирилица';
            case 'id':
                return 'Полето е задължително 10 символа';
            default:
                return '';
        }
    }

    const valdateAllFields = () => {
        for(let field of ['firstNameCyrillic', 'middleNameCyrillic', 'lastNameCyrillic']) {
            if(checkForError(field, 'cyrilic', true)) {
                return false;
            } 
        }
        for(let field of ['city', 'streetName']) {
            if(checkForError(field, 'cyrilic', true, true)) {
                return false;
            }
        }

        return true;
    }

    const checkForDifferentPersonal = () => {
        for(let field in userDataLocal) {
            if(field !== "address") {
                if(userDataLocal[field] !== userDetails[field]) return true;
            }
        }

        return false;
    }

    const checkForDifferentAddress = () => {
        const userAddress = userDetails?.userAddresses ? (userDetails?.userAddresses.find(obj => obj.isUserAddress) || {} ): {};

        for(let field in userDataLocal?.address) {
            if(userDataLocal?.address[field] !== userAddress[field]) return true;
        } 

        return false;
    }

    const createUserBody = () => {
        return {
            email             : userDataLocal?.email,
            firstNameCyrillic : userDataLocal?.firstNameCyrillic,
            middleNameCyrillic: userDataLocal?.middleNameCyrillic,
            lastNameCyrillic  : userDataLocal?.lastNameCyrillic,
            userPubId         : userDataLocal?.userPubId,
            mobTelephone      : userDataLocal?.mobTelephone,
            firstName         : getLatin(userDataLocal?.firstNameCyrillic),
            middleName        : getLatin(userDataLocal?.middleNameCyrillic),
            lastName          : getLatin(userDataLocal?.lastNameCyrillic),
            userType          : "I" // userDetails?.userType
        }
    }

    const submitHandler = async () => {
        if(!valdateAllFields()) return;

        if(checkForDifferentPersonal()) {
            setLoading(true);
console.log('personal')
            const body = createUserBody();
            await dispatch(actionsUser.updateUser(body));
        } 
    
        if(checkForDifferentAddress()) {
            setLoading(true);
console.log('address')
            await dispatch(actionsUser.updateAddress(userDataLocal?.address));
        }

        onForward(4);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Моите данни</h6>
            </div>
            <Divider />
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('firstNameCyrillic', data)} onBlur={()=>onBlurHandler('firstNameCyrillic')} 
                placeholder={"Име"} 
                value={userDataLocal?.firstNameCyrillic}
                error={checkForError('firstNameCyrillic', 'cyrilic')}
                errorMsg={generateErrorMsg('firstNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
         
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('middleNameCyrillic', data)} onBlur={()=>onBlurHandler('middleNameCyrillic')} 
                placeholder={"Презиме"} 
                value={userDataLocal?.middleNameCyrillic}
                error={checkForError('middleNameCyrillic', 'cyrilic')}
                errorMsg={generateErrorMsg('middleNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
       
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('lastNameCyrillic', data)} onBlur={()=>onBlurHandler('lastNameCyrillic')} 
                placeholder={"Фамилия"} 
                value={userDataLocal?.lastNameCyrillic}
                error={checkForError('lastNameCyrillic', 'cyrilic')}
                errorMsg={generateErrorMsg('lastNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
 
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('email', data)}
                                    slice={50}                            
                                    placeholder={"Email"} 
                                    value={userDataLocal?.email}
                                    disabled={true}
                                    styles={{marginBottom: '20px'}}/>  
            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('userPubId', data)} onBlur={()=>onBlurHandler('userPubId')} slice={10} 
                    placeholder={"ЕГН"} 
                    value={userDataLocal.userPubId}
                    styles={{marginBottom: '20px'}}
                     error={checkForError('userPubId', 'id')} 
                     errorMsg={generateErrorMsg('userPubId', 'id')}
                    />

            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('mobTelephone', data)}
                    placeholder={"Телефон"} 
                    disabled={true}
                    value={userDataLocal.mobTelephone} 
                    styles={{marginBottom: '20px'}}/>

            <div className="address-container-one"  style={{marginBottom: '20px'}}>
                <NuInsInputNumLabel onChange={(data)=>onChangeHandler('postalCode', data, true)} onBlur={()=>onBlurHandler('postalCode')}
                                    validationType={"noZero"} slice={4} 
                                    placeholder={"Пощенски код"} 
                                    value={userDataLocal?.address?.postalCode}                                
                                    error={checkForError('postalCode', 'zip', null, true)} 
                                    errorMsg={generateErrorMsg('postalCode', 'zip')}/>
                </div>
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('city', data, true)} onBlur={()=>onBlurHandler('city')}
                                    placeholder={"Град"} 
                                    value={userDataLocal?.address?.city}                                
                                    error={checkForError('city', 'cyrilic', null, true)} 
                                    errorMsg={generateErrorMsg('city', 'cyrilic')}
                                    styles={{marginBottom: '20px'}}/>
              
                <div className="address-container-three"  style={{marginBottom: '20px'}}>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetName', data, true)} onBlur={()=>onBlurHandler('streetName')}
                                        placeholder={"ж.к. / кв. / ул. "} 
                                        value={userDataLocal?.address?.streetName}                                
                                        error={checkForError('streetName', 'cyrilic', null, true)} 
                                        errorMsg={generateErrorMsg('streetName', 'cyrilic')}/>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetNumber', data, true)} onBlur={()=>onBlurHandler('streetNumber')}
                                        placeholder={"№"} 
                                        value={userDataLocal?.address?.streetNumber}                                
                                        error={checkForError('streetNumber')} 
                                        errorMsg={generateErrorMsg('streetNumber')}/>
                    
                </div>
                <div className="address-container-two">
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartmentBuilding', data, true)}
                                        placeholder={"Блок"} 
                                        value={userDataLocal?.address?.apartmentBuilding}
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('entrance', data, true)}
                                        placeholder={"Вход"} 
                                        value={userDataLocal?.address?.entrance}                                
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('floor', data, true)}
                                        placeholder={"Етаж"} 
                                        value={userDataLocal?.address?.floor}                                
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartment', data, true)}
                                        placeholder={"Ап."} 
                                        value={userDataLocal?.address?.apartment}                                
                                        />
                </div>
                <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" 
                        onClick={submitHandler} >Потвърди</button>

                {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
        </div>
    )

}


export default ProfileMyDataEdit;